/**
 * 设置财务信息
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { Modal, message, Form, Input, Typography, Button } from 'antd';

const { Text } = Typography;

const SetInfo = ({
    setRenderMode,
    companyFinancialBaseInfo = {},
    companyBaseInfo = {},
    setUpdate
}) => {

    const [loading, setLoading] = useState(false);

    const container = {
        width: '100%'
    };

    const formLayout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 }
    };

    const tailLayout = {
        wrapperCol: { offset: 16, span: 8 },
    };

    const onFinish = (values) => {
        setLoading(true);
        http('/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.updateCompanyFinancial', { ...values, financialId: companyFinancialBaseInfo.financialId }, 'POST')
            .then(() => {
                message.success('修改财务信息操作成功');
                setLoading(false);
                setUpdate(true);
                setRenderMode(false);
            })
            .catch(error => {
                setLoading(false);
                message.error(error.message);
            });
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    return <Modal
        width={600}
        bodyStyle={{ paddingBottom: '1px' }}
        centered
        title='设置财务信息'
        visible={true}
        confirmLoading={loading}
        onCancel={() => setRenderMode(false)}
        destroyOnClose={true}
        keyboard={true}
        maskClosable={false}
        footer={null}
    >
        <Form
            style={container}
            {...formLayout}
            name='companyFinancialBaseInfo'
            initialValues={companyFinancialBaseInfo}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}>
            <Form.Item label='企业名称'><Text>{companyBaseInfo.companyName}</Text></Form.Item>
            <Form.Item
                label='银行名称'
                name='openBank'
                rules={[
                    { required: true, message: '请输入银行名称' },
                    { max: 200, message: '银行名称长度不超过200' }
                ]}
            >
                <Input placeholder='请输入银行名称' />
            </Form.Item>
            <Form.Item
                label='开户行支行'
                name='bankName'
                rules={[
                    { required: true, message: '请输入开户行支行' },
                    { max: 200, message: '开户行支行长度不超过200' }
                ]}
            >
                <Input placeholder='请输入开户行支行' />
            </Form.Item>
            <Form.Item
                label='银行账户'
                name='bankAccount'
                rules={[
                    { required: true, message: '请输入银行账户' },
                    { max: 200, message: '银行账户长度不超过200' }
                ]}
            >
                <Input placeholder='请输入银行账户' />
            </Form.Item>
            <Form.Item
                label='户名'
                name='bankAccountName'
                rules={[
                    { required: true, message: '请输入户名' },
                    { max: 200, message: '户名长度不超过200' }
                ]}
            >
                <Input placeholder='请输入户名' />
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button
                    type='primary'
                    htmlType='submit'
                    loading={loading}
                >保存</Button>
                <Button
                    style={{ marginLeft: '20px' }}
                    disabled={loading}
                    onClick={() => setRenderMode(false)}>取消</Button>
            </Form.Item>
        </Form>
    </Modal>;
};
SetInfo.propTypes = {
    companyFinancialBaseInfo: PropTypes.object,
    companyBaseInfo: PropTypes.object,
    setRenderMode: PropTypes.func,
    setUpdate: PropTypes.func
};
export default SetInfo;
